import { useEffect, RefObject } from 'react';

type RefType = RefObject<HTMLElement | null>;
type EventHandler = (event: MouseEvent | TouchEvent) => void;

export default function useOnClickOutside(ref: RefType, handler: EventHandler): void {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent): void => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }
      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}
